module.exports = __webpack_public_path__ + "static/media/moodsstudio.e69c6289.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/moodsstudio.webp
// module id = 661
// module chunks = 0